import { CommonModule } from '@angular/common'; 
import { Compiler, Component, EventEmitter, Injectable, ModuleWithComponentFactories, NgModule, ViewContainerRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StorageService } from './storage.service';
import { DirectiveModule } from '../modules/directive/directive.module';
import { PipeModule } from '../modules/pipe/pipe.module';
import { BrowserModule } from '@angular/platform-browser';
import { GridModule } from '../modules/grid/grid.module';
import { MaterialModule } from '../modules/material/material.module';

declare var $:any;

@Injectable({
  providedIn: 'root'
})
export class AppService {

  public updateUser = new EventEmitter(); 

  constructor(
    private dialog: MatDialog,
    private compiler: Compiler,
    private storage: StorageService
  ){ }

  /**
   * 
   * Formatar Valor
   * 
   * @param value 
   * 
   */
   formatarValor(value:any){

    value = value.replace(new RegExp(/[.]/g),"");
    value = value.replace(new RegExp(/[,]/g),".");

    return parseFloat(value);

  }
  /**
   * 
   * Remove acentos
   * 
   */
   removerAcentos(value:any){

    try{
      var string = value;
      var mapaAcentosHex:any 	= {
          a : /[\xE0-\xE6]/g,
          A : /[\xC0-\xC6]/g,
          e : /[\xE8-\xEB]/g,
          E : /[\xC8-\xCB]/g,
          i : /[\xEC-\xEF]/g,
          I : /[\xCC-\xCF]/g,
          o : /[\xF2-\xF6]/g,
          O : /[\xD2-\xD6]/g,
          u : /[\xF9-\xFC]/g,
          U : /[\xD9-\xDC]/g,
          c : /\xE7/g,
          C : /\xC7/g,
          n : /\xF1/g,
          N : /\xD1/g
      };

      for ( var letra in mapaAcentosHex ) {
          var expressaoRegular = mapaAcentosHex[letra];
          string = string.replace( expressaoRegular, letra );
      }

     return string; 
    }catch(e){
      return value;
    }

  }
  /**
   * 
   * Info
   * 
   */
   info(message="",tipo='info',width='350px',height='auto'){

    /*this.dialog.open(MatModalInfoComponent,{ 
      width: width,
      height: height,
      data:{
        message: message,
        tipo: tipo
      }
    });*/

  }
  /** 
   * 
   * Cria um Component Runtime
   * 
   */
   createComponentFactorySync(compiler: Compiler, metadata: Component, componentClass: any):any {
  
    const cmpClass = componentClass || class RuntimeComponent { };
    const decoratedCmp = Component(metadata)(cmpClass);
 
    const decoratedNgModule = NgModule({
      imports:[
        BrowserModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        DirectiveModule,
        PipeModule,
        GridModule,
        MaterialModule
      ], declarations: [decoratedCmp] })(cmpClass);

    const module: ModuleWithComponentFactories<any> = compiler.compileModuleAndAllComponentsSync(decoratedNgModule);
     
    return module.componentFactories.find(f => f.componentType === decoratedCmp);
 
 
  }  
  /**
   * 
   * Compila um template
   * 
   */
  compileTemplate(
    html: any,
    container:ViewContainerRef,
    Class:any=null,
    isContext=true,
    dataItem=null,
    grid=null,
    data=null
  ){
    
    let factory = null;

    let metadata = {
      selector: `runtime-component-sample`,
      template: html
    };

    if(Class != null && isContext){
      
      let context = Class;
  
      Class = class RuntimeComponent{

        context  = context;
        dataItem = dataItem;
        data     = data;
        grid     = grid;
 
      };

    }

    factory = this.createComponentFactorySync(this.compiler,metadata,Class);       
    return container.createComponent(factory);

  }
  /**
   * 
   * Envia para o topo
   * 
   * 
   */
   toTop(){ 
         
    $('html, body').stop().animate({ 
      scrollTop: 0
    }, 500);
   

  }
  /**
   * 
   * 
   * 
   */
  permiteFaturar(){

    let user = this.storage.getUser();

    if(user != null){
      return user.permiteFaturar == true || user.permiteFaturar == 'true' ? true : false;
    }else{
      return false;
    }

  }
  /**
   * 
   * Check mobile
   * 
   */
  isMobile(){
   
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor);
    return check;
  
  }
  
}
